import {addClass, getCookie, makeElement, removeClass, setCookie} from '../../common/Utils';
import { ncBannerOptions } from '../../interface/ICommonbanner';
import {checkCookie} from './checkCookie';
import { setStartEndDateTime } from '../utils/Utils';

/**
 * @category Commonbanner
 * @description
 * 플로팅 배너
 * 서브페이지에서만 노출
 * 닫기 클릭 -> 브라우저 쿠키가 삭제 되기 전까지 팝업 안됨
 */

class FloatingLayer{
    isCookieApply: boolean;    
    bannerEl!: HTMLElement;
    el!: HTMLElement;         
    constructor(_isMain: boolean = false, _isLauncher:boolean = false, _data:ncBannerOptions) {

        this.isCookieApply = checkCookie();
        let thisIsCookieApply = this.isCookieApply && getCookie(_data.floatingBanner.Cookie);

        if( _isMain || !_data.floatingBanner.show || thisIsCookieApply ){
            return;
        }

        if ( _isLauncher && !_data.floatingBanner.LauncherShow) {
            return;
        }

        setStartEndDateTime(_data, _data.floatingBanner, this.templateFloating.bind(this));        
    }    

    templateFloating(_data: ncBannerOptions){

        this.bannerEl = this.template(_data) ;

        document.body.appendChild( this.bannerEl );
        this.addEvents(_data);

        setTimeout(()=> {
            addClass( this.bannerEl , 'is-show');
        }, 1000);
    }

    template(_data: ncBannerOptions){
        this.el = makeElement( `
            <div class="nc-banner" data-type="floating">
                ${_data.floatingBanner.Link != ''?`
                <a href="${_data.floatingBanner.Link}" ${_data.floatingBanner.LinkNewWindow ? 'target=_blank' :''} class="nc-banner-link" style="background-image:url('${_data.floatingBanner.BG}')">
                <span class="blind">${_data.floatingBanner.Title}</span>
                </a>
                ` :`
                <span class="nc-banner-link" style="background-image:url('${_data.floatingBanner.BG}')">
                <span class="blind">${_data.floatingBanner.Title}</span>
                </span>
                `}
                <button class="nc-banner-close"><span class="blind">그만보기</span></button>
            </div>
        ` );

        return this.el;
    }

    addEvents(_data:ncBannerOptions){
        const dataTypeFloating = document.querySelector(".nc-banner[data-type=floating]") as HTMLElement;
        document.querySelector(".nc-banner[data-type=floating] .nc-banner-close")?.addEventListener('click', e =>{
            if(this.isCookieApply) {
                setCookie('ncBanner'+_data.floatingBanner.Cookie, "true", 100, '.ncsoft.com'); // 쿠키 사용 (lineage2m nct)
                setCookie('ncBanner'+_data.floatingBanner.Cookie, "true", 100, '.ncsoft.jp'); // 쿠키 사용 (lineage2m ncj)
                setCookie('ncBanner'+_data.floatingBanner.Cookie, "true", 100, '.plaync.com'); // 쿠키 사용
            }
            removeClass(dataTypeFloating, 'is-show');
        });
    }

}
export default FloatingLayer;